// Row-level status chips for the eligibility table. Both the Forecast/Scaling
// status chip and the Readiness chip render `.dq-chip` variants, which are
// shared with the modal ladders (see ForecastDataQa.scss).
import cn from 'classnames';
import { Readiness, READINESS_LABEL } from '../data-qa-copy';
import { grainLabel, statusKind } from '../data-qa-utils';

export const StatusChip = ({
  eligible,
  recommendedGrain,
  downgraded
}: {
  eligible: boolean;
  recommendedGrain: string;
  downgraded: boolean;
}) => {
  switch (statusKind(eligible, recommendedGrain, downgraded)) {
    case 'ready':
      return <span className='dq-chip dq-pass'>Ready</span>;
    case 'rollup':
      return <span className='dq-chip dq-rollup'>Via {grainLabel(recommendedGrain)}</span>;
    default:
      return <span className='dq-chip dq-none'>No path</span>;
  }
};

const READINESS_CHIP: Record<Readiness, string> = {
  good: 'dq-pass',
  check: 'dq-ident-caution',
  directional: 'dq-ident-risk',
  not_enough: 'dq-none'
};

// Row-level Readiness cell: one plain verdict per row, with the reasons on hover.
export const ReadinessCell = ({ level, reasons }: { level: Readiness; reasons: string }) => (
  <span className={cn('dq-chip', READINESS_CHIP[level])} title={reasons}>
    {READINESS_LABEL[level]}
  </span>
);
